import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {ajaxCall} from "./ServerFunctions";

export const fetchLecturersList = createAsyncThunk('lecturers/fetch', async () => {
    const element = document.getElementById('lecturers-list');
    const dataEventId = element?.getAttribute('data-event-id');

    // TODO: Uncomment this code if you want to use the ajaxCall function and fix it accordingly
    // if (dataEventId) {
    //     const result = await ajaxCall({
    //         action: "lecturers_list",
    //         payload: {
    //             event_id: dataEventId
    //         }
    //     });
    //     if (result) {
    //         return result;
    //     }
    // }else {
    //     const result = await ajaxCall({action: "lecturers_list"})
    //
    //     if (result) {
    //         return result;
    //     }
    // }

    const url = dataEventId ? `lecturers/?event_id=${dataEventId}` : 'lecturers';
    try {
        const {data} = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/${url}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Organization-Code': 'LIMMUD_BALTICS'
                },
            }
        );

        return data;
    } catch (e) {

    }
    return [];
});
